import React from "react";

import { Container, Stack } from "@mui/material";

import {
  SettingSubtitle,
  SettingTitle,
} from "@app/analytics/account/components/styles";
import TextField from "@app/analytics/components/TextField";
import useReadAdmin from "@app/analytics/hooks/useReadAdmin";
import { toast } from "@app/common/hooks/useToasts";
import usePageTitle from "@app/utils/hooks/usePageTitle";

import Button from "@rui/Button";

import SettingsCard from "./account/components/SettingsCard";

const Admin = () => {
  usePageTitle("Admin");

  const { startImpersonation } = useReadAdmin();

  const handleClickImpersonate: React.FormEventHandler<HTMLFormElement> = (
    e
  ) => {
    e.preventDefault();
    const emailToImpersonate = e.currentTarget.email.value;
    startImpersonation.mutate(emailToImpersonate, {
      onSuccess: () => {
        toast.success("Success! Redirecting...");
      },
      onError: () => {
        toast.error("Something went wrong");
      },
    });
  };

  return (
    <Stack sx={{ width: "100%" }}>
      <Container maxWidth="sm">
        <SettingsCard>
          <Stack>
            <form onSubmit={handleClickImpersonate}>
              <Stack spacing={2}>
                <SettingTitle>Impersonate User</SettingTitle>
                <SettingSubtitle>
                  Impersonate a user. To stop impersonating a user, simply log
                  out.
                </SettingSubtitle>
                <TextField
                  label="Email"
                  helperText=""
                  id="email"
                  type="email"
                />
                <Button loading={startImpersonation.isPending} type="submit">
                  Submit
                </Button>
              </Stack>
            </form>
          </Stack>
        </SettingsCard>
      </Container>
    </Stack>
  );
};

export default Admin;
